/**
 * PSIFY IMMERSIVE — Capability detection
 * Returnează profilul experienței: 'full' | 'lite' | 'static'
 *  - static: prefers-reduced-motion → fără Lenis, fără WebGL, fără pinning
 *  - lite:   dispozitive modeste → fără Three.js, dar cu reveals GSAP
 *  - full:   experiența completă
 */
export function detectProfile() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return 'static'
  }

  // Save-Data activat → respectăm
  if (navigator.connection && navigator.connection.saveData) {
    return 'lite'
  }

  // Doar memoria raportată mică retrogradează la lite.
  // (Telefoanele moderne — inclusiv iPhone — duc lejer scena WebGL;
  //  primesc profil "full" cu calitate redusă în webgl.js)
  const lowMemory = navigator.deviceMemory !== undefined && navigator.deviceMemory < 4

  if (lowMemory) {
    return 'lite'
  }

  // WebGL disponibil?
  try {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl2') || canvas.getContext('webgl')
    if (!gl) return 'lite'
  } catch (e) {
    return 'lite'
  }

  return 'full'
}
